export type ALIGNMENT = 'BOTTOM_RIGHT';

export const getMenuPosition = ({
  menuAlignment = 'BOTTOM_RIGHT',
  menuWidth = 0,
  triggerPosition,
}: {
  menuAlignment: ALIGNMENT;
  menuWidth: number;
  triggerPosition?: DOMRect;
}) => {
  if (!triggerPosition) {
    return {};
  }

  return {
    BOTTOM_RIGHT: {
      top: triggerPosition.bottom + window.scrollY,
      left: triggerPosition.right - menuWidth,
    },
  }[menuAlignment];
};
